const setupSwiper = (selector) => {
	new Swiper(selector, {
		slidesPerView: 6,
		slidesPerGroup: 4,
		slidesPerView: 4,
		slidesPerGroup: 2,
		spaceBetween: 6,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			699: {
				slidesPerView: 6,
				slidesPerGroup: 4,
			},
		},
	})
}

// Product recommendations are dynamically added with JS.
// To prevent race condition, initialize the product recommendation slides individually
// after ensuring product recommendations are loaded.

// handle all slides excluding from product recommendations
setupSwiper('.swiper')

// handle product recommendations swatches
let maxSliderIntervalCallsLeft = 10

const waitForProdRecSliders = () => {
	maxSliderIntervalCallsLeft--

	if (maxSliderIntervalCallsLeft === 0) {
		clearInterval(prodRecSlidersTimerId)
	}

	const productRecSwatches = document.querySelectorAll(
		'product-recommendations .swiper'
	)

	if (productRecSwatches.length === 0) {
		return
	}

	setupSwiper('.swiper')

	clearInterval(prodRecSlidersTimerId)
}

prodRecSlidersTimerId = setInterval(waitForProdRecSliders, 200)
